import { getStoreAccessors } from 'vuex-typescript';
import { ActionContext } from 'vuex';
import { axios } from '@zyf2e/adapt';

import { USER, USER_API } from '@/constant';
import { IgetImEntranceCheck, IgetImEntranceCheckParam } from '@/store/user/index.d';

interface IuserState {
  riskBookAgreed: boolean;
}

type UserContext = ActionContext<IuserState, {}>;

export const userPersistField = ['riskBookAgreed'];

const user = {
  namespaced: true,
  state: {
    riskBookAgreed: false
  },
  mutations: {
    setRiskBookAgreed(state: IuserState, isAgree: boolean) {
      Object.assign(state, {
        riskBookAgreed: isAgree
      });
    }
  },
  actions: {
    checkIMActivity(context: UserContext, params: IgetImEntranceCheckParam): Promise<IgetImEntranceCheck> {
      return axios.get(USER_API.CHECK_IM_ACTIVITY, { params });
    }
  }
};

const { commit, dispatch } = getStoreAccessors<IuserState, {}>(USER);
const { mutations, actions } = user;
const { setRiskBookAgreed } = mutations;
const { checkIMActivity } = actions;

export const commitSetRiskBookAgreed = commit(setRiskBookAgreed);

export const dispatchCheckIMActivity = dispatch(checkIMActivity);

export default user;
